/**
 * Hook to fetch registered caregiver contacts from user_settings.
 * Replaces the old hardcoded contactsStore for send flow checks.
 */
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export interface CaregiverContact {
  id: string;
  nickname: string;
  notificationType?: "all" | "messages_only";
}

export function useCaregiverContacts() {
  const { user } = useAuth();
  const [contacts, setContacts] = useState<CaregiverContact[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchCaregivers() {
      if (!user) {
        setIsLoading(false);
        return;
      }
      try {
        const { data, error } = await supabase
          .from("user_settings")
          .select("caregiver_push_tokens")
          .eq("user_id", user.id)
          .maybeSingle();

        if (error) throw error;

        if (data?.caregiver_push_tokens && Array.isArray(data.caregiver_push_tokens)) {
          const mapped: CaregiverContact[] = (data.caregiver_push_tokens as any[]).map(
            (t: any, i: number) => ({
              id: `caregiver-${i}`,
              nickname: t.nickname || t.deviceInfo?.split(" ")[0] || `מטפל ${i + 1}`,
              notificationType: t.notificationType || "all",
            })
          );
          setContacts(mapped);
        }
      } catch (err) {
        console.error("[useCaregiverContacts] Error fetching caregivers:", err);
      } finally {
        setIsLoading(false);
      }
    }
    fetchCaregivers();
  }, [user]);

  return { contacts, isLoading, hasContacts: contacts.length > 0 };
}
